'use client';

import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails,
} from '@packages/shared/src/ui/Accordion/Accordion';
import { StatusChip } from '@packages/shared/src/ui/StatusChip/StatusChip';
import { Notification } from '@packages/shared/src/ui/Notification/Notification';
import type { PriceCurrency } from '@packages/gql/generated/shopping/graphql';
import { APlus } from '../APlus';
import type { AplusControlledSelection } from '../Layouts/types';
import type { APlusItems } from '../types';

type AplusAccordionProps = {
  items: APlusItems;
  currency: PriceCurrency;
  quantity?: number;
  /** the selection to render and where to report changes, see `useAplusSelection` */
  controlled: AplusControlledSelection;
  /** shows the notification that the last change could not be saved */
  hasSaveError?: boolean;
};

export const AplusAccordion = ({
  items,
  currency,
  quantity,
  controlled,
  hasSaveError,
}: AplusAccordionProps) => {
  const [accordionKey, setAccordionKey] = useState('aplus');

  return (
    <>
      {hasSaveError && (
        <Notification severity="error">
          <FormattedMessage
            id="Aplus.saveError"
            defaultMessage="Änderung konnte nicht gespeichert werden"
          />
        </Notification>
      )}
      <Accordion type="single" collapsible value={accordionKey} onValueChange={setAccordionKey}>
        <AccordionItem value="aplus" noStyle>
          <AccordionSummary className="text-size-body-sm">
            {accordionKey !== 'aplus' && (
              <StatusChip color="success" className="mr-2">
                <FormattedMessage id="Aplus.hint" defaultMessage="TIPP" />
              </StatusChip>
            )}
            <FormattedMessage id="Aplus.order" defaultMessage="Einfach mitbestellen" />
          </AccordionSummary>
          <AccordionDetails>
            <APlus
              layout="ListItems"
              items={items}
              currency={currency}
              quantity={quantity}
              controlled={controlled}
            />
          </AccordionDetails>
        </AccordionItem>
      </Accordion>
    </>
  );
};
